import { Menu, Transition } from '@headlessui/react'
import SignupButton from 'components/Buttons/SignupButton'
import Translation from 'components/Translation'
import { useAppContext } from 'context/AppContext'
import { useAuth } from 'context/AuthContext'
import { Fragment } from 'react'
import logout from 'services/cognito/logout'
import { classNames } from 'utils/dom-helpers'
import { useRouter } from 'next/router'
import { RoleTypes } from 'types/staff'
import getConfig from 'next/config'
import { HelpIcon, MobileScreenIcon, SettingsIcon, SignoutIcon, UserIcon } from 'utils/custom-icons'
import { useTenantContext } from 'context/TenantContext'
interface Props {
    locale?: string
}
export function UserDropdown({ locale }: Props) {
    const { translations, locale: locale_cached } = useAppContext()
    const { user, hasRole, user_profile, LoginModal } = useAuth()
    const { sidebar_items } = useTenantContext()
    const router = useRouter()

    async function killSession() {
        try {
            await logout()
            localStorage.removeItem("banner_hidden")
            const { API_ENDPOINT, LANDING_PAGES_HOST} = getConfig().publicRuntimeConfig
            if (API_ENDPOINT.includes('stg')) {
                location.href = '/'
            } else {
                document.location = LANDING_PAGES_HOST
                // router.push(`${newUrl}/`)
            }
            
        } catch (e) {
            console.error(e)
        }
    }

    return user?.first_name ? (
        <Menu as="div" className="relative">
            <div>
                <Menu.Button className="bg-custom-dark-cyan-blue items-center w-8 h-8 text-center justify-center py-1 px-2 flex v-center text-white text-md font-bold rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-custom-dark-cyan-blue focus:ring-white">
                    <span className="sr-only">Open user menu</span>
                    {user_profile?.user &&
                        user_profile?.user.imageUrl?.length ? (
                        <img
                            className="w-7 h-7 rounded-full max-w-none"
                            src={user_profile?.user.imageUrl}
                            alt="profile"
                        />
                    ) : (
                        user?.first_name[0]
                    )}
                </Menu.Button>
            </div>
            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items className="z-20 w-48 origin-top-right absolute right-0 mt-2 rounded-md shadow-lg py-1 bg-gray-100 ring-1 ring-black ring-opacity-5 focus:outline-none">
                    {hasRole([RoleTypes.SUPER_ADMIN, RoleTypes.ADMIN]) && (
                        <Menu.Item>
                            {({ active }) => (
                                <button
                                    onClick={() => router.push('/dashboard/profile/')}
                                    className={classNames(
                                        active ? 'bg-gray-200' : '',
                                        'w-full flex flex-row items-center gap-2 text-left block px-4 py-2 text-sm text-gray-900 hover:bg-primary-lighter'
                                    )}
                                >
                                    <UserIcon style={{ width: '14px', height: '14px' }}/>
                                    <Translation
                                        render_as="span"
                                        className="align-middle"
                                        content_key="account"
                                        translations={translations}
                                    />
                                </button>
                            )}
                        </Menu.Item>
                    )}
                    {
                        sidebar_items.find(item => item.translation_key === 'sign_in_kiosk')?.is_hidden == false &&
                    <Menu.Item>
                        {({ active }) => (
                            <button
                                onClick={() => router.push(`/dashboard/sign_in_kiosk`)}
                                className={classNames(
                                    active ? 'bg-gray-200' : '',
                                    'w-full flex flex-row items-center gap-2 text-left block px-4 py-2 text-sm text-gray-900 hover:bg-primary-lighter'
                                )}
                            >
                                <MobileScreenIcon style={{ width: '14px', height: '14px' }}/>
                                <Translation
                                    render_as="span"
                                    className="align-middle"
                                    content_key="sign_in_kiosk"
                                    translations={translations}
                                />
                                <span className='bg-blue-400 uppercase rounded-md inline text-white text-[10px] p-1 ml-1 float-right'>
                            New
                        </span>
                            </button>
                        )}
                    </Menu.Item>
                    }
                    {
                        (hasRole([RoleTypes.SUPER_ADMIN]) || sidebar_items.find(item => item.translation_key === 'settings')?.is_hidden == false) &&
                    <Menu.Item>
                        {({ active }) => (
                            <button
                                onClick={() => router.push(`/dashboard/settings/basic?lang=${locale || locale_cached}`)}
                                className={classNames(
                                    active ? 'bg-gray-200' : '',
                                    'w-full flex flex-row items-center gap-2 text-left block px-4 py-2 text-sm text-gray-900 hover:bg-primary-lighter'
                                )}
                            >
                                <SettingsIcon style={{ width: '14px', height: '14px', color: '#5E9FBD' }} />
                                <Translation
                                    render_as="span"
                                    className="align-middle"
                                    content_key="settings"
                                    translations={translations}
                                />
                            </button>
                        )}
                    </Menu.Item>
                    }
                    {
                        sidebar_items.find(item => item.translation_key === 'helps')?.is_hidden == false &&
                    <Menu.Item>
                        {({ active }) => (
                            <button
                                onClick={() => window.open("http://help.aot.plus/", '_blank')?.focus()}
                                className={classNames(
                                    active ? 'bg-gray-200' : '',
                                    'w-full flex flex-row items-center gap-2 text-left block px-4 py-2 text-sm text-gray-900 hover:bg-primary-lighter'
                                )}
                            >
                                <HelpIcon style={{ width: '14px', height: '14px' }} />
                                <Translation
                                    render_as="span"
                                    className="align-middle"
                                    content_key="helps"
                                    translations={translations}
                                />
                            </button>
                        )}
                    </Menu.Item>
                    }
                    <Menu.Item>
                        {({ active }) => (
                            <button
                                onClick={killSession}
                                className={classNames(
                                    active ? 'bg-gray-200' : '',
                                    'w-full flex flex-row items-center gap-2 text-left block px-4 py-2 text-sm text-gray-900 hover:bg-primary-lighter'
                                )}
                            >
                                <SignoutIcon style={{ width: '14px', height: '14px' }} />
                                <Translation
                                    render_as="span"
                                    className="align-middle"
                                    content_key="sign_out"
                                    translations={translations}
                                />
                            </button>
                        )}
                    </Menu.Item>
                </Menu.Items>
            </Transition>
        </Menu>
    ) : (
        <>
            <button
                type="button"
                className="font-display text-black"
                onClick={() => {
                    // window.history.replaceState({ ...window.history.state, as: "/login", url: "/login" }, '', "/login")
                    router.push('/login-page')
                    // LoginModal.open()
                }}
            >
                <Translation
                    content_key="login"
                />
            </button>

            <SignupButton
                className="button primary inline-block px-5 p-2"
                translations={translations}
            />
        </>
    )
}

export default UserDropdown
